import { css, SelectInput, styled, SelectInputProps } from 'canoe';
import React from 'react';

import { ValueBoxConsumer } from '../ValueBox';

const BaseInput = styled(SelectInput)<{ hasError?: boolean; prefix?: string }>`
  ${({ theme, hasError, prefix }) => css`
    height: 32px;
    padding: 0 ${theme.spaces.xs};
    font-size: ${theme.fonts.small.fontSize};

    ${prefix &&
    css`
      padding-left: ${theme.spaces.xxs};

      + label {
        height: 32px;
        font-size: ${theme.fonts.small.fontSize};
        padding: ${theme.spaces.xxs} ${theme.spaces.xs} ${theme.spaces.xxs} ${theme.spaces.xs};
      }
    `}

    ${hasError &&
    css`
      outline: 1px solid ${theme.colors.Danger};
    `}
  `}
`;

const StyledInput = styled(BaseInput)<{
  isInGroup?: boolean;
  isFirst?: boolean;
  isLast?: boolean;
  isExpandable?: boolean;
  isExpanded?: boolean;
  hasBoxLabel?: boolean;
}>`
  ${({ isInGroup, isFirst, isLast, isExpandable, isExpanded, hasBoxLabel }) => css`

    ${
      hasBoxLabel &&
      css`
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      `
    }

    ${
      isInGroup &&
      css`
        ${groupStyles({ isFirst, isLast, hasBoxLabel })};
      `
    }

    ${
      isExpandable &&
      css`
        ${expandableStyles({ isExpanded, hasBoxLabel })};
      `
    }
  `}
`;

const groupStyles = ({
  isFirst,
  isLast,
  hasBoxLabel,
}: {
  isFirst?: boolean;
  isLast?: boolean;
  hasBoxLabel?: boolean;
}) => css`
  ${
    isFirst &&
    css`
      border-bottom-right-radius: 0;
    `
  }
  ${
    isLast &&
    css`
      border-top-right-radius: 0;
    `
  }

  ${
    !isFirst &&
    !isLast &&
    css`
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    `
  }

  ${
    !hasBoxLabel &&
    css`
      ${
        isFirst &&
        css`
          border-bottom-left-radius: 0;
        `
      }
      ${
        isLast &&
        css`
          border-top-left-radius: 0;
        `
      }

      ${
        !isFirst &&
        !isLast &&
        css`
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        `
      }
    `
  }
`;

const expandableStyles = ({
  isExpanded,
  hasBoxLabel,
}: {
  isExpanded?: boolean;
  hasBoxLabel?: boolean;
}) => css`
  ${isExpanded &&
  css`
    border-bottom-right-radius: 0;

    ${!hasBoxLabel &&
    css`
      border-bottom-left-radius: 0;
    `}
  `}
`;

export interface DefaultListItemProps {
  value: number | string;
  label: string;
  description?: string;
  prefix?: string;
  sufix?: string;
}

interface ValueSelectInputProps<T = DefaultListItemProps> extends SelectInputProps<T> {
  notInBox?: boolean;
}

export const ValueSelectInput = <Item extends object = DefaultListItemProps>({
  notInBox,
  ...rest
}: ValueSelectInputProps<Item>) => {
  return (
    <ValueBoxConsumer>
      {(contextValues) => (
        <>
          {Object.keys(contextValues).length && !notInBox ? (
            <StyledInput {...contextValues} {...rest} />
          ) : (
            <BaseInput {...rest} />
          )}
        </>
      )}
    </ValueBoxConsumer>
  );
};
